import React from 'react';
import Chip, { Color, Width } from 'lib/Chip';
import { NetworkRangeValue } from './ProductNetwork.types';

export const ProductNetworkChipList: React.FC<{
  groupedRangeValues: NetworkRangeValue;
  onRemoveChip: (networksToRemove?: string[]) => void;
}> = ({ groupedRangeValues, onRemoveChip }) => {
  return (
    <div className="flex w-full flex-col items-end gap-1">
      {Object.entries(groupedRangeValues).map(([networkName, networkRangeValues]) => (
        <React.Fragment key={networkName}>
          <Chip
            label={networkName}
            color={Color.PRIMARY}
            width={Width.FULL}
            onRemove={() => onRemoveChip([networkName])}
          />
          {Object.entries(networkRangeValues).map(([rangeKey, rangeValue]) => (
            <Chip key={`${networkName}-${rangeKey}`} label={rangeKey} subLabel={rangeValue} color={Color.PRIMARY} />
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};
